/**
 * Encarteirados Service (mocked, API-ready)
 *
 * Exposes jobs that are already booked/mapped but not yet reflected in
 * Receita. These represent future revenue that the CEO wants to track
 * alongside the current DRE numbers.
 *
 * When the backend endpoint is ready, replace the mock implementation
 * with the real tRPC query. Keep the hook return shape identical so
 * consumers don't need to change.
 */

export interface EncarteiradoJob {
  id: string
  job: string
  client: string
  pit?: string
  /** Expected month (1-12) when the revenue will be recognized */
  mesPrevisto: number
  value: number
  category: 'promo' | 'digital'
}

export interface EncarteiradosResult {
  /** Total value of encarteirados jobs in R$ */
  value: number
  jobs: EncarteiradoJob[]
  isLoading: boolean
}

// TODO(api): Replace with real tRPC query
const MOCK_JOBS: EncarteiradoJob[] = [
  { id: '1', job: 'Campanha Verão 2026', client: 'Cliente A', pit: 'PIT-2026-010', mesPrevisto: 5, value: 350_000, category: 'promo' },
  { id: '2', job: 'Ativação PDV', client: 'Cliente B', pit: 'PIT-2026-011', mesPrevisto: 6, value: 220_000, category: 'promo' },
  { id: '3', job: 'Social Media Q3', client: 'Cliente C', pit: 'PIT-2026-012', mesPrevisto: 7, value: 180_000, category: 'digital' },
  { id: '4', job: 'Performance Ads', client: 'Cliente A', pit: 'PIT-2026-013', mesPrevisto: 5, value: 150_000, category: 'digital' },
  { id: '5', job: 'Evento Lançamento', client: 'Cliente D', mesPrevisto: 8, value: 400_000, category: 'promo' },
]

export function useEncarteirados(): EncarteiradosResult {
  const value = MOCK_JOBS.reduce((s, j) => s + j.value, 0)
  return {
    value,
    jobs: MOCK_JOBS,
    isLoading: false,
  }
}
